const searchTagIdentifier = '#';
const searchTagRegExp = `([${searchTagIdentifier}]?\\w+)`;

const isTag = (word) => typeof word === 'string' &&
  word.startsWith(searchTagIdentifier);

// only accept tags which aren't surrounded by non-tags
const trailingOrLeadingTags = (wordOrTag, index, wordsAndTags) => {
  const previous = wordsAndTags[index - 1];
  const next = wordsAndTags[index + 1];

  return isTag(wordOrTag) &&
         ((!previous || isTag(previous)) ||
         (!next || isTag(next)));
};

const getTagsFromQuery = (query) => {
  const wordsAndTags = [];
  const regexp = new RegExp(searchTagRegExp, 'g');

  let match = regexp.exec(query);
  while (match !== null) {
    wordsAndTags.push(match[1]);
    match = regexp.exec(query);
  }

  const tags = wordsAndTags.filter(trailingOrLeadingTags);
  return tags.map((tag) => tag.replace(searchTagIdentifier, ''));
};

const addTagToQuery = (query, tag) => [
  query,
  ' ',
  searchTagIdentifier,
  tag,
].join('');

const removeTagFromQuery = (query, tag) => query
  .replace(`${searchTagIdentifier}${tag}`, '')
  .trim();

module.exports = {
  searchTagIdentifier,
  addTagToQuery,
  getTagsFromQuery,
  removeTagFromQuery,
};
